import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CAT_LABEL } from "./Categories";
import { designImg } from "./designsApi";

export const CategoryEditor = ({ d, onSaved }) => {
  const [sel, setSel] = useState([]);
  const [group, setGroup] = useState([]);
  useEffect(() => {
    setSel(d.categories?.length ? d.categories : (d.ai_categories || []).filter((a) => a.confidence >= 50).map((a) => a.key));
    if (d.group_size > 1) api.get(`/designs/${d.id}/group`).then(({ data }) => setGroup(data.items)).catch(() => {});
    else setGroup([]);
  }, [d]);
  const save = async () => {
    try {
      const { data } = await api.put(`/designs/${d.id}/categories`, { categories: sel });
      toast.success("Category save ho gayi — aage AI isse seekhega");
      onSaved?.({ ...d, categories: data.categories, cat_locked: true, cat_source: "user", cat_review: false });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const groupOk = async () => {
    try { await api.post(`/designs/${d.id}/group-ok`); toast.success("Theek hai"); onSaved?.({ ...d, group_doubt: false }); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const ai = Object.fromEntries((d.ai_categories || []).map((a) => [a.key, a.confidence]));
  return (
    <div className="space-y-2" data-testid="design-cat-editor">
      <div className="text-xs text-slate-400">
        Category {d.cat_source === "example" ? "(pakka example)" : d.cat_source === "user" ? "(aapne confirm ki)" : d.ai_categories ? "(AI draft)" : ""}
      </div>
      <div className="flex flex-wrap gap-1">
        {Object.entries(CAT_LABEL).map(([k, l]) => (
          <button key={k} type="button" onClick={() => setSel((s) => (s.includes(k) ? s.filter((x) => x !== k) : [...s, k]))}
            className={"text-[11px] px-2 py-1 rounded-sm border " + (sel.includes(k) ? "bg-orange-500 border-orange-500 text-white" : "border-slate-700 text-slate-300")}
            data-testid={`cat-edit-${k}`}>
            {l}{ai[k] != null ? ` ${ai[k]}%` : ""}
          </button>
        ))}
      </div>
      <Button size="sm" onClick={save} disabled={!sel.length} className="w-full rounded-sm bg-slate-100 text-slate-900 hover:bg-white" data-testid="cat-edit-save">CATEGORY SAVE</Button>
      {group.length > 1 && (
        <div className="pt-2" data-testid="design-group-strip">
          <div className="text-xs text-slate-400 mb-1">Same design ({group.length}): {group.map((g) => g.serial_label).join(", ")}</div>
          <div className="flex gap-1 overflow-x-auto">
            {group.map((g) => <img key={g.id} src={designImg(g.id, true, g.rendered_at)} alt={g.serial_label} className="h-14 w-14 object-contain bg-white rounded-sm" />)}
          </div>
        </div>
      )}
      {d.group_doubt && (
        <Button size="sm" variant="outline" onClick={groupOk} className="w-full rounded-sm border-amber-500/50 text-amber-300 bg-slate-950" data-testid="group-doubt-ok">
          Milta-julta design hai par alag rakha — theek hai
        </Button>
      )}
    </div>
  );
};
